import { render, staticRenderFns } from "./UploadBox.vue?vue&type=template&id=64a25408&scoped=true&"
import script from "./UploadBox.vue?vue&type=script&lang=js&"
export * from "./UploadBox.vue?vue&type=script&lang=js&"
import style0 from "./UploadBox.vue?vue&type=style&index=0&id=64a25408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a25408",
  null
  
)

export default component.exports